import Cookies from 'js-cookie';

// Check authentication for admin
const isAdminAuthenticated = () => {
  const token = Cookies.get('admin_auth_token');
  return !!token; // Returns true if admin token exists
};

// Check authentication for user
const isUserAuthenticated = () => {
  const token = Cookies.get('user_auth_token');
  return !!token; // Returns true if user token exists
};

// Save admin token and email
const saveAdminToken = (token, email) => {
  try {
    Cookies.set('admin_auth_token', token, { expires: 7 });
    Cookies.set('admin_email', email, { expires: 7 });
    console.log('Admin auth token and email saved successfully:', token, email);
  } catch (error) {
    console.error('Error saving admin token and email:', error);
  }
};

// Save user token and email
const saveUserToken = (token, email) => {
  try {
    Cookies.set('user_auth_token', token, { expires: 7 });
    Cookies.set('user_email', email, { expires: 7 });
    console.log('User auth token and email saved successfully:', token, email);
  } catch (error) {
    console.error('Error saving user token and email:', error);
  }
};

// Remove admin token and email
const removeAdminToken = () => {
  try {
    Cookies.remove('admin_auth_token');
    Cookies.remove('admin_email');
    console.log('Admin auth token and email removed successfully');
  } catch (error) {
    console.error('Error removing admin token and email:', error);
  }
};

// Remove user token and email
const removeUserToken = () => {
  try {
    Cookies.remove('user_auth_token');
    Cookies.remove('user_email');
    console.log('User auth token and email removed successfully');
  } catch (error) {
    console.error('Error removing user token and email:', error);
  }
};

// Get admin email
const getAdminEmail = () => {
  return Cookies.get('admin_email') || null;
};

// Get user email
const getUserEmail = () => {
  return Cookies.get('user_email') || null;
};

// get user token
const getUserToken = () => {
  return Cookies.get('user_auth_token') || null;
};

//get admin token
const getAdminToken = () => {
  return Cookies.get('admin_auth_token') || null;
};


export {
  isAdminAuthenticated,
  isUserAuthenticated,
  saveAdminToken,
  saveUserToken,
  removeAdminToken,
  removeUserToken,
  getAdminEmail,
  getUserEmail,
  getUserToken,
  getAdminToken
};
